// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const FitToScreenOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 32 32","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M22 16h2V8h-8v2h6v6zM8 24h8v-2h-6v-6H8v8z"}},{"tag":"path","attrs":{"d":"M26 28H6a2 2 0 01-2-2V6a2 2 0 012-2h20a2 2 0 012 2v20a2 2 0 01-2 2zM6 6v20h20V6z"}},{"tag":"path","attrs":{"d":"M0 0h32v32H0z","fill":"none"}}]},"name":"fit_to_screen","theme":"outlined"};

const FitToScreenOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={FitToScreenOutlinedSvg} />;
  FitToScreenOutlined.displayName = 'FitToScreenOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(FitToScreenOutlined);
